<template>
	<div class="notLogin">
		<img class="notLoginImg" src="../assets/logo.png" alt="" />
		<span class="notLoginTitle">未登录</span>
		<span class="notLoginOther">
			<span @click="gotoLogin" class="notLoginMe">请前去登录&nbsp;></span>
		</span>
	</div>
</template>

<script>
	export default {
		methods: {
	      gotoLogin(){
			let pageTo=encodeURIComponent(location.href)
			// location.href = 'https://www.guigui.com.cn/login.html?other=true&pageTo=' + pageTo
	        location.href='./login.html?pageTo='+pageTo
	      }
		}
	}
</script>

<style>
	.notLogin {
		position: relative;
		width: 300px;
		height: 100px;
		margin-bottom: 10px;
		border-radius:10px;
		background-color: #ffffff;
	}
	.notLogin .notLoginImg {
		position: absolute;
		width: 50px;
		height: 50px;
		left: 60px;
		top: 50%;
		margin-top: -25px;
		border-radius: 50%;
	}
	.notLogin .notLoginTitle {
		position: absolute;
		display: inline-block;
		left: 126px;
		top: 25px;
		font-size: 16px;
		color: #4D4D4D;
		font-weight: bold;
	}
	.notLogin .notLoginOther {
		position: absolute;
		display: inline-block;
		left: 126px;
		bottom: 25px;
		font-size: 13px;
		color: #4D4D4D;
	}
	.notLogin .notLoginMe {
		color: #5147E7;
    	cursor: pointer;
    	font-size: 13px;
    	letter-spacing: 1px;
    	padding-bottom: 2px;
    	border-bottom: 1px solid #5147E7;
	}
</style>